import React from 'react';
import CanvasCardFront from '@/components/Summary/Cards/CanvasCardFront';
import cardBackImg from '../../images/card-back.png';
// JSX-based card components kept but replaced by canvas/image approach
// import { NuLifeSpanCardFront, NuLifeSpanCardBack } from "@/components/Summary/Cards/NuLifeSpanCard";

/**
 * DiscountCard Component
 * Used on the Signup / homepage "Our Discount Cards" section.
 * Front: canvas-based (CanvasCardFront with card-front.png).
 * Back:  plain <img> (card-back.png). No wallet buttons needed here.
 *
 * @param {string} side        - 'front' | 'back'
 * @param {string} bin
 * @param {string} pcn
 * @param {string} groupNumber
 * @param {string} memberId
 */
const DiscountCard = ({
    side = 'front',
    bin = '023518',
    pcn = 'ARX',
    groupNumber = 'RXH1234',
    memberId = 'AX129063',
}) => {
    return (
        <div className="flex justify-center">
            {side === 'front' ? (
                <CanvasCardFront
                    isCvs={false}
                    bin={bin}
                    pcn={pcn}
                    groupNumber={groupNumber}
                    memberId={memberId}
                    className="w-full max-w-[480px]"
                />
            ) : (
                <img
                    src={cardBackImg}
                    alt="Prescription Savings Card — Back"
                    style={{ borderRadius: 16, display: 'block', height: 'auto' }}
                    className="w-full max-w-[480px]"
                />
            )}
        </div>
    );
};

export default DiscountCard;
